module.exports = __webpack_public_path__ + "static/media/banner_glipbox.791f4d7a.png";